export default axios => ({
    getPermisos(rol = '') {
        rol = rol == 0 ? '' : rol;
        return axios.get(`/admin/permisos/`+rol)
    },
    updatePermisos(data) {
        return axios.put(`/admin/permisos/`+data.rol_id, data)
    },
})
